const numberFormat = new Intl.NumberFormat('en-GB')
const formatCurrency = function (value, withCurrencySign) {

    if (typeof value === 'number') {
        let currency = numberFormat.format(value);
        if (withCurrencySign) {
            currency = '£' + currency;
        }
        return currency
    }

    if (value.substr(-1, 1) === '.') {
        return value
    }

    const v = Number(value.replace(/,/g, ''));

    if (!isNaN(v)) {
        let currency = numberFormat.format(v);
        if (withCurrencySign) {
            currency = '£' + currency;
        }
        return currency
    } else {
        return value
    }
}

export {
    formatCurrency
}
